import { IcoChevronLeft } from "../components/icons";
import { usePageTitle } from "../hooks";

export function Page() {
  usePageTitle("Page Not Found");
  return (
    <div class="min-h-screen bg-surface flex items-center justify-center p-4">
      <div class="max-w-md w-full text-center">
        <div class="text-6xl font-bold text-text-subtle mb-4">404</div>
        <h1 class="text-xl font-semibold text-text mb-2">Page not found</h1>
        <p class="text-text-muted mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <a
          href="/"
          class="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg font-medium text-text bg-surface-muted hover:bg-surface-hover transition-colors"
        >
          <IcoChevronLeft class="size-4" />
          Back to home
        </a>
      </div>
    </div>
  );
}
